import {
  fetch,
  normalize,
  extractHubURL,
} from '../../utils/dataAccess';
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'LIVEINTERVIEW_SHARE_LINK_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'LIVEINTERVIEW_SHARE_LINK_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'LIVEINTERVIEW_SHARE_LINK_LIST_SUCCESS', retrieved };
}

export function list(page = 'live_interview_share_links') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        retrieved = normalize(retrieved);

        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch(success(null));
    dispatch(loading(null));
    dispatch(error(null));
  };
}

export function filter(filtersData) {
  return filterAction('LIVEINTERVIEW_SHARE_LINK_LIST_FILTER', 'live_interview_share_links', filtersData)
}

export function sort(sortData) {
  return sortAction('LIVEINTERVIEW_SHARE_LINK_LIST_SORT', 'live_interview_share_links', sortData)
}
